import RolesRoute from './RolesRoute';

export default RolesRoute;
